// extracted by mini-css-extract-plugin
export default {"portfolioErrorContainer":"styles_portfolioErrorContainer__328sV","spinnerWrapper":"styles_spinnerWrapper__2r44o","moneyCalculateIcon":"styles_moneyCalculateIcon__CbTQq"};